import script from "./OrdersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersPage.vue?vue&type=script&setup=true&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=5fc4ac28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc4ac28"]])

export default __exports__